import { Component } from '@angular/core';

@Component({
  selector: 'eid-desktop-error',
  templateUrl: './desktop-error.component.html',
  styleUrls: ['./desktop-error.component.scss']
})
export class DesktopErrorComponent {}
